<template>
    <div class="relative">

        <div v-show="errorMessage.length > 0">
            <div class="text-red-600">
                {{ errorMessage }}
            </div>
            <hr/>
        </div>

        <div v-show="promisePending && errorMessage.length === 0" class=" absolute top-0 right-0 animate-spin text-center flex justify-center items-center">
            <i class=" fas fa-spinner w-6 h-6"></i>
        </div>

        <div v-if="gotCredentials && credentials.length === 0">
             <!-- nom du credential airtable -->
            <label for="airtable_credential">Credential airtable</label>
            <input
                id="airtable_credential"
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="airtable_credential"
                placeholder="Credential airtable"/>
        </div>
        <div v-else-if="credentials.length >= 1">
            <!-- nom du credential airtable -->
            <label for="airtable_credential">Credential airtable</label>
            <b-form-select
                id="airtable_credential"
                v-model="airtable_credential" :options="credentials"
                
                class="mb-2">
            </b-form-select>
        </div>
        <div v-if="gotCredentials && (credentials.length === 0 || credentials.length > 1)">
            <b-button :variant="airtable_credential.length > 0 ? 'success' : ''" :disabled="airtable_credential.length === 0"
                @click="() => get_bases()">
                Valider
            </b-button>
        </div>

        <div v-show="baseList.length > 0">
            <!-- base ID -->
            <label for="airtable_base_id">Base Airtable</label>
            <b-form-select
                id="airtable_base_id"
                v-model="airtable_base_id" :options="baseOptions"
                class="mb-2">
            </b-form-select>
        </div>
        
        <div v-show="airtable_base_id.length > 0">
            <!-- table name -->
            <label for="airtable_table_id">Nom de la table Airtable</label>
            <b-form-select
                id="airtable_table_id"
                v-model="airtable_table_id" :options="tableOptions"
                class="mb-2">
            </b-form-select>
        </div>

        <div>
            <b-button :variant="info_filled ? 'success' : ''" :disabled="!info_filled"
                @click="() => get_records()">
                Valider
            </b-button>
        </div>

        <hr/>

        <edit_tabulator
            v-show="dataLoaded"
            :extern_file="false"
            @data="() => {}"
            @update="() => {}"
            @add_row="() => {}"
            @delete_row="() => {}"
            @update_row="() => {}"
            ref="table_data">
        </edit_tabulator>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import airtable_service from "../../services/airtable.js";
import edit_tabulator from "../edit_tabulator.vue";

const errorMessage = ref('');
const promisePending = ref(false);

const gotCredentials = ref(false);
const credentials = ref([]);
const airtable_credential = ref('');

const baseList = ref([]);
const baseOptions = ref([]);

const tablesList = ref([]);
const tableOptions = ref([]);

const airtable_base_id = ref('');
const airtable_table_id = ref('');

const dataLoaded = ref(false);
const table_data = ref();

const get_credentials = async () => {
    promisePending.value = true;

    let credentialsRes = await airtable_service.get_credentials();

    // construct a list with text and value
    credentials.value = credentialsRes.map(c => {
        return { text: c.name, value: c.name };
    });

    console.log("Got credential choices: ", credentials.value);
    if (credentials.value.length > 0) {

        console.log("Assigning airtable credential to: ", credentials.value[0].value);
        airtable_credential.value = credentials.value[0].value;

        await get_bases();
    } else {
        promisePending.value = false;
    }
    gotCredentials.value = true;
}

get_credentials();

const info_filled = computed(() => {
    return airtable_credential.value.length > 0
        && airtable_base_id.value.length > 0
        && airtable_table_id.value.length > 0;
});

const get_records = async () => {
    errorMessage.value = "";

    // change mouse to waiting state
    // document.body.style.cursor = 'wait';
    promisePending.value = true;

    if (info_filled.value) {

        console.log("table id", airtable_table_id.value);

        let records = await airtable_service.get_records(airtable_credential.value,
                                        airtable_base_id.value,
                                        airtable_table_id.value)
                                        .catch(err => {
                                            errorMessage.value = "Erreur lors de la récupération des valeurs";
                                        });

        if (records === undefined || errorMessage.length > 0) {
            promisePending.value = false;
            return;
        }

        console.log("Got records: ", records);
        dataLoaded.value = true;
        let values = records.records.map(r => {
            return r.fields;
        });

      table_data.value.load(values);
    }

    promisePending.value = false;
}

const get_bases = async () => {
    errorMessage.value = "";
    // document.body.style.cursor = 'wait';
    promisePending.value = true;

    console.log("Get bases with airtable credential: ", airtable_credential.value);

    let result = await airtable_service.get_bases(airtable_credential.value)
                                                .catch(err => {
                                                    errorMessage.value = err.name === 401 ?
                                                        "Erreur d'authentification, vérifiez le nom et la valeur de votre credential"
                                                        : "Erreur lors de la récupération des bases";
                                                });

    if (result === undefined) {
        promisePending.value = false;
        return;
    }

    baseList.value = result.bases;

    baseOptions.value = baseList.value.map(b => {
        return { text: b.name, value: b.id };
    });

    if (baseOptions.value.length > 0) {
        airtable_base_id.value = baseOptions.value[0].value;
    } else {
        promisePending.value = false;
        errorMessage.value = "Aucune base trouvée";
    }

}
const get_tables = async () => {
    promisePending.value = true;

    errorMessage.value = "";

    console.log("Get tables with airtable credential: ", airtable_credential.value);
    // document.body.style.cursor = 'wait';

    let result = await airtable_service.get_tables(airtable_credential.value, airtable_base_id.value)
                                                .catch(err => {
                                                    errorMessage.value = err.name === 401 ?
                                                        "Erreur d'authentification, vérifiez le nom et la valeur de votre credential"
                                                        : "Erreur lors de la récupération des tables";
                                                });

    if (result === undefined) {
        promisePending.value = false;
        return;
    }
    console.log("Got tables: ", result);
    tablesList.value = result.tables;

    tableOptions.value = tablesList.value.map(t => {
        return { text: t.name, value: t.id };
    });

    if (tableOptions.value.length > 0) {
        airtable_table_id.value = tableOptions.value[0].value;
        promisePending.value = false;
    } else {
        promisePending.value = false;
        errorMessage.value = "Aucune table trouvée";
    }
}

watch(airtable_base_id, () => {
    get_tables();
});


const get_data = () => {
  return table_data.value.get_data();
}

const get_data_files = () => {
  return table_data.value.get_data_files();
}

const get_data_blob = () => {
  return table_data.value.get_data_blob();
}

const save = () => {
  return table_data.value.save();
}

const load = (data) => {
  table_data.value.load(data);
}

const init = (data) => {
  table_data.value.init(data);
}

const set_data = (data) => {
  table_data.value.set_data(data);
}

defineExpose({
    get_data,
    get_data_files,
    save,
    load,
    init,
    set_data,
    get_data_blob
});

</script>